export function formatarMoedaBRL(valor: number | string | undefined | null): string {
  const numero = typeof valor === 'string' ? parseFloat(valor.replace(',', '.')) : valor;

  if (numero === null || numero === undefined || isNaN(numero as number)) {
    return '';
  }
  const formatadorPadrao = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  let valorFormatado = formatadorPadrao.format(numero as number);
  if (valorFormatado.endsWith(',00')) {
    valorFormatado = valorFormatado.replace(',00', '');
  }
  return valorFormatado;
}

export function formatarPesoVolume(
  valor: number | string | undefined | null,
): string {
  const numero = typeof valor === 'string' ? parseFloat(valor.replace(',', '.')) : valor;

  if (numero === null || numero === undefined || isNaN(numero as number)) {
    return '';
  }
  const numeroFormatado = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numero as number);
  return `${numeroFormatado}`;
}